var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyesG(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 22,
    viewBox: "0 0 100 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(-1,1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67 0C71.0538 6.07439 86.6868 6.07447 100 0C100 9.38773 67 14.3577 67 0Z",
    fill: "#181111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33 0C28.9462 6.07439 13.3132 6.07447 0 0C0 9.38773 33 14.3577 33 0Z",
    fill: "#181111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 17.875C4 15.0404 6.00052 12.375 8.00141 11C10.0016 12.375 12 15.125 12 17.875C12 20.625 10.6684 22 8.00141 22C5.33443 22 4 20.7096 4 17.875Z",
    fill: "#B3E1E4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyesG);
export default __webpack_public_path__ + "static/media/Eyes G.343c0526240dd911243c9ec06162777c.svg";
export { ForwardRef as ReactComponent };